import { IMembro } from '@/@types/EstruturaOrganizacional';
import { ContainerMembros } from '@/components/shared/ContainerMembros';
import { Loading } from '@/components/shared/Loading';
import { MembroItem } from '@/components/shared/MembroItem';
import { api } from '@/services/api';
import { useEffect, useState } from 'react';

const ComposicaoCG = () => {
    const [composicaoCG, setComposicaoCG] = useState<IMembro[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getComposicaoCG = async () => {
            setIsLoading(true);
            const url = '/feagri/colegiados/orgao/sigla/CG';

            await api.get(url)
                .then(response => {
                    setComposicaoCG(response.data);
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => setIsLoading(false));

        }

        getComposicaoCG();

    }, []);

    return(
        <>
            <h1>Composição da Comissão de Graduação - CG</h1>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <ContainerMembros>
                    {composicaoCG.map(representante => {
                        return (
                            <MembroItem key={representante._id} data={{
                                representanteFuncao: representante.funcao.funcaoweb,
                                representanteNome: representante.representante.nome,
                                representanteTitulo: representante.representante.funcao_representante,
                                representanteSubfuncao: representante.subfuncao?.subfuncaoweb,
                                foto: representante.representante.foto
                            }} />
                        );
                    })}
                </ContainerMembros>
            )}
        </>
    );
}

export { ComposicaoCG };